import { doc, setDoc } from 'firebase/firestore';
import { Add, Close, Man, QuestionMark, Woman } from '@mui/icons-material';
import { Box, Button, Dialog, DialogContent, DialogTitle, Typography } from '@mui/material';
import React, { useCallback, useState } from 'react';
import { firestore } from '../firebaseSetup/firebase';
import { useUser } from '../providers/UserProvider';

export const GENDERS = [
  { label: 'Unknown', val: 'unknown' },
  { label: 'Man', val: 'men', order: 1 },
  { label: 'Woman', val: 'women', order: 2 },
  { label: 'Trans Man', val: 'transmen', order: 3 },
  { label: 'Trans Woman', val: 'transwomen', order: 4 },
  { label: 'Non-Binary', val: 'nonBinary', order: 5 },
  { label: 'Genderqueer', val: 'genderqueer', order: 6 },
  { label: 'Genderfluid', val: 'genderfluid', order: 7 },
  { label: 'Agender', val: 'agender', order: 8 },
  { label: 'Two-Spirit', val: 'twoSpirit', order: 9 },
  { label: 'Intersex', val: 'intersex', order: 10 },
  { label: 'Other', val: 'other', order: 11 },
];

const AddCount = () => {
  const { user } = useUser();
  const [open, setOpen] = useState(false);
  const [saving, setSaving] = useState(false);
  const [moreOpen, setMoreOpen] = useState(false);

  const handleAdd = useCallback((gender) => {
    const newGender = {};
    if (gender && gender !== 'unknown') {
      newGender[gender] = (user?.genders?.[gender] || 0) + 1;
    }
    setSaving(true);
    const newCount = (user?.count || 0) + 1;
    // Write count and genders to private subcollection
    setDoc(
      doc(
        firestore,
        'users',
        user?.uid,
        'private',
        'data',
      ),
      {
        count: newCount,
        genders: {
          ...user?.genders,
          ...newGender,
        },
      },
      { merge: true },
    ).then(() => {
      // Cloud Functions will handle notifications via onCountUpdate trigger
    }).catch((error) => {
      console.error('Error writing new message to Firebase Database', error);
    }).finally(() => {
      setOpen(false);
      setSaving(false);
    });
  }, [user]);

  return (
    <>
      <Button onClick={() => setOpen(true)}>
        <Add sx={{ fontSize: 32 }} />
      </Button>
      <Dialog keepMounted open={open} onClose={() => setOpen(false)}>
        <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="body1">
            Add Bodycount
          </Typography>
          <Button sx={{ minWidth: 'unset', mr: -1 }} onClick={() => setOpen(false)}>
            <Close />
          </Button>
        </DialogTitle>
        <DialogContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', p: 2 }}>
          {
            !moreOpen && (
              <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', gap: 1 }}>
                <Button
                  disabled={saving}
                  variant="outlined"
                  color="primary"
                  onClick={() => handleAdd('men')}
                >
                  <Man sx={{ fontSize: 50, m: 2 }} />
                </Button>
                <Button
                  disabled={saving}
                  variant="outlined"
                  color="primary"
                  onClick={() => handleAdd()}
                >
                  <QuestionMark sx={{ fontSize: 50, m: 2 }} />
                </Button>
                <Button
                  disabled={saving}
                  variant="outlined"
                  color="primary"
                  onClick={() => handleAdd('women')}
                >
                  <Woman sx={{ fontSize: 50, m: 2 }} />
                </Button>
              </Box>
            )
          }
          {
            moreOpen && (
              <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
                {
                  GENDERS.map((g, i) => (
                    <Box sx={{ boxSizing: 'border-box', py: 0.5, pl: i !== 0 && i % 2 === 0 ? 0.5 : 0, pr: i !== 0 && i % 2 !== 0 ? 0.5 : 0, width: i === 0 ? '100%' : '50%' }} key={g.val}>
                      <Button
                        disabled={saving}
                        variant="outlined"
                        color="primary"
                        onClick={() => handleAdd(g.val)}
                        sx={{ width: '100%', fontSize: 12, fontFamily: 'quicksand' }}
                      >
                        {g.label}
                      </Button>
                    </Box>
                  ))
                }
              </Box>
            )
          }
          <Button sx={{ mt: 1 }} onClick={() => setMoreOpen((old) => !old)}>{moreOpen ? 'Less' : 'More'}</Button>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default AddCount;
